import Table from '../../components/Table/Table';
import Tabs from '../../components/Tabs/Tabs';
import type { ESgMovementDataProps } from './interfaces';

const ESgMovementData = ({
  currentMonthData,
  lastMonthData,
}: ESgMovementDataProps) => {
  const currentMonthTabItem = {
    navItem: {
      headline: 'Aktueller Monat',
    },
    content: currentMonthData ? (
      <Table tableData={currentMonthData} color="surrogate" layout="auto" />
    ) : null,
  };

  const lastMonthTabItem = {
    navItem: {
      headline: 'Letzter Monat',
    },
    content: lastMonthData ? (
      <Table tableData={lastMonthData} color="surrogate" layout="auto" />
    ) : null,
  };

  return (
    <Tabs
      items={[lastMonthTabItem, currentMonthTabItem]}
      initialItem={currentMonthTabItem}
      alignNavItems="right"
      noShadow
    />
  );
};

export default ESgMovementData;
